import React, { Component } from "react";
import { string } from "prop-types";
import Col from "../grid/Col";
import Button from "../button/Button";
import UploadButton from "../button/UploadButton";
import FaCamera from "react-icons/lib/fa/camera";
import "./ImageUpload.css";

class ImageUpload extends Component {
  static PropTypes = {
    profile_photo_url: string,
    uploadText: string
  };

  constructor(props) {
    super(props);
    this.state = {
      file: "",
      imagePreviewUrl: "",
      confirmation: false,
      range: 100
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleRangeChange = this.handleRangeChange.bind(this);
    this.apply = this.apply.bind(this);
    this.cancel = this.cancel.bind(this);
    this.renderImg = this.renderImg.bind(this);
  }

  handleChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file, // TODO: upload or do something with this
        imagePreviewUrl: reader.result,
        confirmation: true
      });
    };

    reader.readAsDataURL(file);
  }

  handleRangeChange(e) {
    this.setState({ range: e.target.value });
  }

  apply() {
    this.props.apply({ file: this.state.file, range: this.state.range });
    this.setState({ confirmation: false });
  }

  cancel() {
    this.setState({
      confirmation: false,
      imagePreviewUrl: "",
      range: 100
    });
  }

  renderImg() {
    const { imagePreviewUrl, range } = this.state;
    const imageStyles = {
      width: range + "%"
    };

    if (imagePreviewUrl || this.props.photoUrl) {
      return (
        <img
          src={imagePreviewUrl || this.props.photoUrl}
          alt=""
          style={imageStyles}
        />
      );
    } else {
      return (
        <div className="image-placeholder">
          <div className="circle">
            <FaCamera className="camera" />
          </div>
        </div>
      );
    }
  }

  componentWillUpdate(nextProps, nextState) {
    const { confirmation } = this.state;
    if (nextState.confirmation !== confirmation) {
      document.body.classList.toggle("focused-out", nextState.confirmation);
    }
  }

  render() {
    const { confirmation, range } = this.state;
    return (
      <div
        className="image-upload"
        style={confirmation ? { zIndex: 99999 } : { zIndex: 0 }}
      >
        <Col _bottom-16 _no-grow>
          <div className="thumbnail">{this.renderImg()}</div>
          {confirmation && (
            <Col _bottom-16 _no-grow>
              <input
                type="range"
                min={100}
                max={200}
                value={range}
                onChange={this.handleRangeChange}
              />
              <Button className="btn-green btn-square" onClick={this.apply}>
                Apply Changes
              </Button>
              <Button className="btn-red btn-square" onClick={this.cancel}>
                Cancel
              </Button>
            </Col>
          )}
          {!confirmation && (
            <UploadButton
              className="btn-blue btn-square"
              onChange={this.handleChange}
              accept="image/*"
            >
              {this.props.uploadText || "Upload"}
            </UploadButton>
          )}
        </Col>
      </div>
    );
  }
}

export default ImageUpload;



// WEBPACK FOOTER //
// ./src/common/image/ImageUpload.js